import { useApplyInsertionDataUpdate } from '../../../../../../logic/useApplyInsertionDataUpdate'
import { useAppSelector } from '../../../../../../../app/hooks'
import { InitState } from '../../../../../../../redux/reducers/root/initialState'
import {
  ContentStateInterface,
  isEditEntryMode,
  OnChangeValue,
  ScreenProperty,
} from '../../../../../../../@types/types'
import { useCallback } from 'react'
import { formatNumberForDisplay } from '../../../../../../../i18next/decimal'

export function useOnPriceChange() {
  const applyInsertionDataUpdate = useApplyInsertionDataUpdate()
  const entryMode = useAppSelector(
    (state: InitState) => state.insertionFeature.insertionIdentification.metaInformation?.entryMode
  )
  const flowInformation = useAppSelector((state: InitState) => state.flowFeature.flowInformation)
  const formState = useAppSelector((state: InitState) => state.formStateFeature)
  const depositCalculationEnabled =
    !isEditEntryMode(entryMode) &&
    flowInformation.options?.depositCalculationEnabled === true &&
    !formState?.touched['deposit']

  return useCallback(
    (screenProperty: ScreenProperty, value: OnChangeValue) => {
      applyInsertionDataUpdate((old): ContentStateInterface => {
        const updateDeposit = !depositCalculationEnabled || !value

        return {
          ...old,
          [screenProperty.property]: value,
          deposit: updateDeposit ? old.deposit : formatNumberForDisplay(Number(value) * 3),
        }
      })
    },
    [depositCalculationEnabled, applyInsertionDataUpdate]
  )
}
